import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  productCard: {
    borderStyle: "solid",
    borderWidth: 2,
    borderColor: "#3C67FF",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: 170,
    height: 450,
    borderRadius: 10,
    backgroundColor: "white",
    margin: 10,
    paddingBottom: 20,
    // height: 359,
  },
  productCardList: {
    borderStyle: "solid",
    borderWidth: 2,
    borderColor: "#3C67FF",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    borderRadius: 10,
    backgroundColor: "white",
    margin: 10,
    paddingBottom: 20,
    paddingTop: 2,
    paddingLeft: 2,
    width: "90%",
  },
  fab: {
    position: "absolute",
    right: 24,
    bottom: 32,
    backgroundColor: "#007AFF",
    borderRadius: 28,
    width: 56,
    height: 56,
    alignItems: "center",
    justifyContent: "center",
    elevation: 4,
  },
  productCardList2: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "90%",
    borderRadius: 10,
    backgroundColor: "white",
    margin: 10,
    paddingBottom: 20,
  },
  pTitleList: {
    fontWeight: "700",
    fontSize: 15,
    textTransform: "uppercase",
    textAlign: "left",
  },
  pTitle: {
    fontWeight: "700",
    fontSize: 13,
    textTransform: "uppercase",
    textAlign: "center",
  },
  pPrice: {
    fontSize: 13,
    fontWeight: "500",
    marginTop: 5,
  },
  oldPrice: {
    fontSize: 16,
    fontWeight: "500",
    marginTop: 5,
    color: "#D60001",
  },
  advice: {
    fontSize: 14,
    fontWeight: "500",
    marginTop: 5,
    color: "#D60001",
    textAlign: "center",
  },
  buyingPrice: {
    fontSize: 20,
    fontWeight: "800",
    marginTop: 5,
    color: "#080680",
  },
  flexBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "start",
  },
  flexBoxCenter: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  searchBar: {
    height: 50,
    margin: 12,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#8F959E",
    padding: 10,
    borderRadius: 10,
    backgroundColor: "white",
    fontSize: 20,
    textAlign: "left",
    marginTop: 30,
    marginBottom: 30,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignContent: "center",
    alignItems: "center",
    marginTop: 10,
  },
  cartItems: {
    height: "100vh",
    width: "100vw",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    position: "absolute",
    zIndex: 9,
    marginHorizontal: "-20px",
    marginVertical: "-18px",
  },
  cartContent: {
    //  height: "80vh",
    marginRight: 20,
    paddingBottom: 30,
    borderRadius: 10,
    width: "80vw",
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    zIndex: 10,
    alignSelf: "flex-end",
    paddingRight: 20,
  },
  menuContent: {
    height: "100vh",
    width: 400,
    backgroundColor: "white",
    zIndex: 10,
    alignSelf: "flex-start",
    padding: 20,
  },
  headerContainer: {
    backgroundColor: "#080680",
    padding: 10,
    paddingTop: 18,
    paddingHorizontal: 20,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100vw",
    zIndex: 99,
    // margin: -10,
  },
  headerTitle: {
    fontSize: 20,
    color: "white",
    marginTop: 5,
    fontWeight: 600,
  },
  headerTitleBlue: {
    fontSize: 28,
    color: "#080680",
    marginTop: 5,
    fontWeight: 600,
    textAlign: "center",
    marginTop: 20,
  },
  cartBubble: {
    backgroundColor: "red",
    color: "white",
    position: "absolute",
    paddingLeft: 3,
    paddingRight: 3,
    borderRadius: 50,
    textAlign: "right",
    left: 25,
  },
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "flex-end",
    backgroundColor: "black",
  },
  blueBack: {
    backgroundColor: "#F4F6FD",
    alignItems: "center",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  centerThis: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  inputLogin: {
    backgroundColor: "white",
    paddingLeft: 10,
    paddingRight: 10,
    marginLeft: 20,
    marginRight: 20,
    borderRadius: 10,
    marginTop: 5,
  },
  inputLabel: {
    color: "#535353",
    fontSize: 18,
    marginLeft: 10,
    marginBottom: 5,
    fontWeight: "300",
  },
  inputText: {
    color: "black",
    fontSize: 20,
    marginLeft: 10,
    padding: 20,
  },
  button: {
    backgroundColor: "#080680",
    borderRadius: 50,
    paddingLeft: 60,
    paddingRight: 60,
    paddingTop: 10,
    paddingBottom: 10,
    marginTop: 20,
    marginHorizontal: 10,
  },
  button2: {
    backgroundColor: "#B70806",
    borderRadius: 0,
    paddingLeft: 60,
    paddingRight: 60,
    paddingTop: 10,
    paddingBottom: 10,
    marginTop: 20,
    marginHorizontal: 10,
  },
  buttonAlt: {
    backgroundColor: "#969696",
    borderRadius: 50,
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 10,
    paddingBottom: 10,
    marginTop: 20,
    marginHorizontal: 70,
  },
  buttonLog: {
    backgroundColor: "#080680",
    borderRadius: 15,
    paddingLeft: 60,
    paddingRight: 60,
    paddingTop: 20,
    paddingBottom: 20,
    marginTop: 20,
    width: "87vw",
  },
  buttonSign: {
    backgroundColor: "#9B9B9B",
    borderRadius: 15,
    paddingLeft: 60,
    paddingRight: 60,
    paddingTop: 20,
    paddingBottom: 20,
    marginTop: 20,
    width: "87vw",
  },
  btnTitle: {
    color: "white",
    fontSize: 20,
    fontWeight: "400",
    textAlign: "center",
  },
  btnTitleAlt: {
    color: "white",
    fontSize: 17,
    fontWeight: "400",
  },
  close: {
    fontSize: 20,
    fontWeight: 600,
    textAlign: "right",
    margin: 20,
  },
  cartItem: {
    borderStyle: "solid",
    borderWidth: 2,
    borderColor: "#080680",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "start",
    borderRadius: 10,
    backgroundColor: "white",
    margin: 10,
    padding: 20,
  },
  cartItemImp: {
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#080680",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "start",
    borderRadius: 5,
    backgroundColor: "white",
    margin: 5,
    padding: 5,
  },
  total: {
    fontWeight: "700",
    fontSize: 15,
    textTransform: "uppercase",
    textAlign: "right",
    marginRight: 10,
    marginTop: 10,
  },
  totalFinal: {
    fontWeight: "700",
    fontSize: 20,
    textTransform: "uppercase",
    textAlign: "right",
    marginRight: 10,
    marginTop: 10,
  },
  totalFinalBlue: {
    fontWeight: "700",
    fontSize: 20,
    textTransform: "uppercase",
    textAlign: "right",
    marginRight: 10,
    marginTop: 10,
    color: "#0A02C6",
  },
  totalFinal2: {
    fontWeight: "700",
    fontSize: 19,
    textTransform: "uppercase",
    textAlign: "right",
    marginRight: 10,
    marginTop: 10,
    color: "red",
  },
  h1checkout: {
    fontWeight: "700",
    fontSize: 15,
    textTransform: "uppercase",
    textAlign: "center",
    color: "white",
    backgroundColor: "#080680",
    padding: 30,
  },
  sideBySide: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  results: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: "blue",
    width: 150,
    padding: 10,
    justifyContent: "space-around",
    borderRadius: 30,
  },
  resultsText: {
    color: "white",
    fontWeight: "600",
  },
  adviceBlue: {
    textAlign: "center",
    color: "#080680",
    // width: 600,
    marginHorizontal: 20,
    marginBottom: 40,
    fontWeight: 600,
    fontSize: 17,
  },
  buttonHome: {
    backgroundColor: "white",
    borderRadius: 10,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
    paddingBottom: 20,
    marginTop: 20,
  },
  pButton: {
    backgroundColor: "#080680",
    borderRadius: 10,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 7,
    paddingBottom: 9,
    marginTop: 20,
  },
  ppButton: {
    backgroundColor: "#080680",
    borderRadius: 10,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 7,
    paddingBottom: 9,
    marginTop: 8,
    marginRight: 10,
    // position: "absolute",
    // top: 10,
    // right: 2,
  },
  pbtnTitle: {
    color: "white",
    fontSize: 16,
    fontWeight: "400",
  },
  btnTitleHome: {
    color: "#080680",
    fontSize: 20,
    fontWeight: "400",
  },
  sectionTitle: {
    textAlign: "left",
    marginLeft: 20,
    color: "#080680",
    width: 800,
    fontWeight: 600,
    fontSize: 25,
    marginTop: 30,
    marginBottom: 10,
  },
  sectionTitleCenter: {
    textAlign: "center",
    marginLeft: 20,
    color: "#080680",
    width: 800,
    fontWeight: 600,
    fontSize: 25,
    marginTop: 30,
    marginBottom: 10,
  },
  discount: {
    backgroundColor: "#080680",
    color: "white",
    fontSize: 20,
    fontWeight: "400",
    alignSelf: "self-start",
    borderBottomRightRadius: 8,
    borderTopLeftRadius: 8,
    paddingBottom: 5,
    marginTop: 0,
    paddingRight: 8,
    paddingLeft: 5,
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 99,
  },
  discountList: {
    backgroundColor: "#080680",
    color: "white",
    fontSize: 15,
    fontWeight: "500",
    alignSelf: "self-start",
    borderBottomRightRadius: 8,
    borderTopLeftRadius: 8,
    paddingBottom: 5,
    marginTop: -1,
    paddingRight: 8,
    paddingLeft: 5,
    position: "absolute",
    zIndex: 99,
  },
});

// azul #080680
export { styles };
